import { Fragment } from 'react';
import {
  values,
  getInnerSlicePath,
  getInnerTextCoordinates,
  getOuterSlicePath,
  getOuterTextCoordinates,
} from '../../CheckIn/checkInValues';
import styles from './CheckInTool.module.scss';

interface Props {
  handleEmotionClick: (arg0: string) => void;
  selectedEmotion: string;
  selectedColor?: string;
}

const CheckInTool = ({ handleEmotionClick, selectedEmotion, selectedColor }: Props): JSX.Element => {
  const handleClick = (emotion: string) => {
    handleEmotionClick(emotion);
  };
  return (
    <div>
      <svg height='520px' width='520px' className={styles.pieArea}>
        {values.map((value, index) => {
          const xOrigin = 260;
          const yOrigin = 260;
          const radius = 125;
          const radiansPerUnit = (2 * Math.PI) / values.length;
          const pathValue = getInnerSlicePath(xOrigin, yOrigin, index * radiansPerUnit, radiansPerUnit, radius);

          const [xTextLocation, yTextLocation] = getInnerTextCoordinates(
            xOrigin,
            yOrigin,
            index * radiansPerUnit,
            radiansPerUnit,
            radius / 1.5,
          );

          return (
            <Fragment key={value.title}>
              <g className={styles.segment}>
                <path d={pathValue} fill={value.segmentColor} stroke='black' />
              </g>
              <text
                className={styles.innerText}
                transform={'rotate(90)'}
                x={xTextLocation}
                y={-yTextLocation}
                fontSize={'13px'}
                fill={index < 3 || index > 5 ? 'black' : 'white'}
                textAnchor='middle'
              >
                {value.title}
              </text>
              {value.subEmotions.map((emotion, subIndex) => {
                const radiansPerEmotion = radiansPerUnit / value.subEmotions.length;
                const emotionIndex = index * values.length + subIndex;
                const emotionPathValue = getOuterSlicePath(
                  xOrigin,
                  yOrigin,
                  emotionIndex * radiansPerEmotion,
                  radiansPerEmotion,
                  radius,
                );
                const [outerTextX, outerTextY] = getOuterTextCoordinates(
                  xOrigin,
                  yOrigin,
                  emotionIndex * radiansPerEmotion,
                  radiansPerEmotion,
                  radius * 1.95,
                );
                const [scaleOriginX, scaleOriginY] = getOuterTextCoordinates(
                  xOrigin,
                  yOrigin,
                  emotionIndex * radiansPerEmotion,
                  radiansPerEmotion,
                  radius,
                );
                const textAngle = (emotionIndex + 0.5) * radiansPerEmotion * 57.2958;
                return (
                  <Fragment key={emotion}>
                    <g
                      className={selectedEmotion === emotion ? styles.outerActive : styles.outerSegment}
                      style={{
                        transformOrigin: `${scaleOriginX}px ${scaleOriginY}px`,
                        '--segment-color': selectedColor || value.subEmotionColor,
                      }}
                      onClick={() => handleClick(emotion)}
                    >
                      <path d={emotionPathValue} fill={selectedColor || value.subEmotionColor} stroke='black' />
                    </g>

                    <text
                      className={styles.outerText}
                      transform={`rotate(${
                        emotionIndex < 24 ? textAngle : textAngle + 180
                      }, ${outerTextX}, ${outerTextY})`}
                      x={outerTextX}
                      y={outerTextY}
                      fontSize={'12px'}
                      fill='black'
                      textAnchor={emotionIndex > 23 ? 'start' : 'end'}
                      alignmentBaseline='middle'
                    >
                      {emotion}
                    </text>
                  </Fragment>
                );
              })}
            </Fragment>
          );
        })}
      </svg>
    </div>
  );
};

export default CheckInTool;
